module.exports = __webpack_public_path__ + "img/chinesecompany156.28b42859.png";